import axios from './util/axios.js'

export function getTopBrands () {
  return axios.get('/api/brands/?top_brands=true')
}
